import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "aoIconUrl"
})
export class AoIconUrlPipe implements PipeTransform {
    transform(value: string): string {
        return value?.replaceAll("Ö", "O");
    }
}
